import { Component, OnInit } from '@angular/core';
import { BreadcrumbComponent } from '../../../../shared/components/breadcrumb/breadcrumb.component';
import { IBreadcrumbConfig } from '../../../../core/interfaces/breadcrumb-config';
import { CommonModule } from '@angular/common';
import { ModalDocumentationComponent } from '../../components/modal-documentation/modal-documentation.component';
import { ModalAddDocumentationComponent } from '../../components/modal-add-documentation/modal-add-documentation.component';
import { ISiniestroResponse } from '@interfaces/siniestro-response.interface';

@Component({
  selector: 'aig-claims-state',
  imports: [
    BreadcrumbComponent,
    CommonModule,
    ModalDocumentationComponent,
    ModalAddDocumentationComponent,
  ],
  templateUrl: './claims-state.component.html',
  styleUrl: './claims-state.component.scss',
})
export class ClaimsStateComponent implements OnInit {
  public claim: ISiniestroResponse | undefined;

  public supportEmail: string = 'backoffice.caixa@icp.es';

  ngOnInit(): void {
    const navigation = history.state;
    this.claim = navigation.claim;
    //console.log(this.claim);
  }

  claimState(arg: number | undefined): string {
    switch (arg) {
      case 2: return '';
      case 3: return 'cancel';
      case 4: return 'finish';
      default:
        return '';
    }
  }

  public visibleVerDocumentacionModal: boolean = false;

  public OpenSeeDoc() {
    this.visibleVerDocumentacionModal = true;
  }
  public CloseSeeDoc() {
    this.visibleVerDocumentacionModal = false;
  }

  public visibleAdjuntarDocumentacionModal: boolean = false;

  public OpenAddDoc() {
    this.visibleAdjuntarDocumentacionModal = true;
  }
  public CloseAddDoc() {
    this.visibleAdjuntarDocumentacionModal = false;
  }
}
